export default {
    path: '/expert',
    components: {
        default: () => import(/* webpackChunkName: "expert" */ '../views/ChildContainer'),
        menu: () => import(/* webpackChunkName: "expert-menu" */ '../views/expert/Menu'),
    },
    children: [
        {
            path: '',
            name: 'ExpertHome',
            component: () => import(/* webpackChunkName: "expert-home" */ '../views/Home'),
        },
        {
            path: 'info-edit',
            name: 'ExpertInfoEdit',
            component: () => import(/* webpackChunkName: "expert-info-edit" */ '../views/expert/ExpertInfoEdit'),
        },
        {
            path: 'taskManage',
            name: 'ExpertTaskManage',
            component: () => import(/* webpackChunkName: "expert-task-manage" */ '../views/expert/ExpertTaskManage'),
        },
        {
            path: 'taskEdit',
            name: 'ExpertTaskEdit',
            component: () => import(/* webpackChunkName: "expert-task-edit" */ '../views/expert/ExpertTaskEdit'),
        },
        {
            path: 'taskProjectEdit/:projectId',
            name: 'TaskProjectEdit',
            component: () => import(/* webpackChunkName: "expert-task-edit" */ '../views/expert/TaskProjectEdit'),
        },
    ]
}